<template>

    <div>
        <div class="pageback"></div>
        <div class="pagemain">
            <div class="container">
                <div class="row">
                    <div class="col-sm-2" v-if="webW">
                        <div id="JfLeftMenuOut">
                            <div :class="(fixedLeftmenu?'fixedMenuCls':'')"
                                 :style="fixedLeftmenu?('width:'+LeftMenuWidth+'px'):''" id="JfLeftMenu">

                                <SearchLeft></SearchLeft>

                            </div>

                            <div v-if="fixedLeftmenu" :style="'width:'+LeftMenuWidth+'px'"><br></div>
                        </div>
                    </div>
                    <div :class="(webW?'col-sm-10':'col-sm-12')">
                        <div class="baiseback">
                            <el-switch
                                    v-if="webW"
                                    @click="openAutoReflashFunc"
                                    style="float: right;"
                                    active-text="下拉刷新"
                                    v-model="openAutoReflash"
                                    active-color="#13ce66"
                                    inactive-color="#dddddd">
                            </el-switch>
                            <table>
                                <tr>
                                    <td>
                                        <el-input v-model="query.keywords" placeholder="帖子标题搜索"
                                                  class="handle-input mr10"></el-input>
                                    </td>
                                    <td>
                                        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜帖子
                                        </el-button>
                                    </td>
                                </tr>
                            </table>


                        </div>


                        <ForumItemSearchForum></ForumItemSearchForum>


                        <div class="baiseback" v-if="tableDataloading">
                            <div class="center">
                                <img src="../../../assets/img/loading.gif">
                                <p class="typedesc">数据加载中....</p>
                            </div>
                        </div>
                        <div class="baiseback" style="height: 100vh;" v-if="!tableDataloading&&tableData.length==0">
                            <div class="center">
                                <img src="../../../assets/img/zwsj.png">
                                <p class="typedesc">暂无数据</p>
                            </div>
                        </div>
                        <div class="baiseback">
                            <div class="center" v-if="webW">
                                <el-pagination
                                        @current-change="handlePageChange"
                                        :current-page="query.pageNo"
                                        :page-size="query.pageSize"
                                        layout="total, prev, pager, next"
                                        :total="pageTotal">
                                </el-pagination>
                            </div>
                            <p class="typedesc center" v-if="tableDataFinish">没有数据了</p>
                            <Footer></Footer>
                        </div>


                    </div>
                </div>
            </div>
        </div>
        <div class="h100"></div>
        <img src="../../../assets/img/top.png" @click="gotopFunc" v-if="scrolltop" class="gotop hander">
    </div>

</template>

<script>


    import {dealResult, getWindowWidth} from "../../../api/common";

    import SearchLeft from "./SearchLeft";
    import Footer from "../Footer";
    import ForumItemSearchForum from "../index/ForumItemSearchForum";
    import {searchForum} from "../../../api";
    import PubSub from "pubsub-js";

    export default {
        name: 'SearchUser',
        components: {
            SearchLeft,
            Footer,
            ForumItemSearchForum,
        },
        data() {
            return {
                lander: {},
                webW: true,
                scrolltop: false,
                openAutoReflash: true,
                //菜单固定
                fixedLeftmenu: false,
                LeftMenuWidth: 0,

                query: {
                    pageNo: 1,
                    pageSize: 10,
                    keywords: '',
                },
                pageTotal: 0,

                tableData: [],
                tableDataloading: false,
                tableDataFinish: false,//避免滚动条在最后一直请求


            }
        },
        methods: {
            goUhome(t) {
                this.$router.push('Home?authorId=' + t.id + "&type=myforum")
            },
            openAutoReflashFunc() {
                if (this.openAutoReflash) this.tableDataFinish = false;
            },
            gotopFunc() {
                if (document.documentElement != undefined) document.documentElement.scrollTop = 0;
                if (document.body != undefined) document.body.scrollTop = 0;
            },
            // 分页导航
            handlePageChange(val) {
                this.query.pageNo = val;
                this.tableData = [];
                this.searchForum();

                this.tableDataFinish = false;

                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;

            },
            handleSearch() {
                if (this.query.keywords == '') {
                    this.$message.error('请输入标题');
                    return;
                }
                this.query.pageNo = 1;
                this.tableData = [];
                PubSub.publish('forumDataListForItem_searchForum', null);
                this.searchForum()
            },
            //获取 分页
            searchForum() {
                if (this.query.keywords == '') return;
                this.tableDataloading = true;
                this.tableDataFinish = false;

                this.query.uid = this.lander.uid;
                this.query.token = this.lander.token;
                this.query.typeId = this.Team_typeId;


                searchForum(this.query).then((res) => {
                    this.tableDataloading = false;
                    dealResult(res.data);


                    if (res.data.status == 1) {
                        let li = res.data.obj.list;
                        if (li.length == 0) {

                            this.tableDataFinish = true;

                            return;
                        }
                        for (let i = 0; i < li.length; i++) {
                            li[i].hidden = true;
                            li[i].showComments = false;
                            li[i].commentli = [];
                            li[i].commentliLoading = false;

                            li[i].iscollect = "0";
                            li[i].ishit = "0";

                            li[i].voteItemli = [];
                            li[i].ivote = '0';
                            li[i].myvoteDx = '';
                            li[i].myvoteMx = [];

                            li[i].nowvideo={vindex:0,isshow:'0'};
                        }


                        this.tableData = this.tableData.concat(li);
                        PubSub.publish('forumDataListForItem_searchForum', li);


                        this.tableData = this.tableData.concat(li);
                        this.pageTotal = res.data.obj.total//该页总共多少条记录

                        if (this.openAutoReflash) {
                            if (res.data.obj.hasNextPage) this.query.pageNo = res.data.obj.nextPage;
                            else this.query.pageNo = this.query.pageNo + 1;
                        }

                        this.fixedmenu();


                    } else {
                        this.tableDataFinish = true;
                        this.$message.error(res.data.msg)
                    }
                })
            },

            fixedmenu() {
                let that = this;

                let JfLeftMenu = document.getElementById('JfLeftMenu');


                window.onscroll = function () {

                    let t = document.documentElement.scrollTop || document.body.scrollTop;
                    let h = document.documentElement.scrollHeight;
                    let wh = document.documentElement.clientHeight;


                    if (that.webW) {

                        that.LeftMenuWidth = JfLeftMenu.offsetWidth;


                        //t+wh=h

                        //必须写到onscroll里，因为高度是会变化的
                        let leftHeight = JfLeftMenu.offsetHeight;
                        let leftTop = JfLeftMenu.offsetTop;
                        if (t > leftTop + leftHeight) {
                            that.fixedLeftmenu = true;
                        } else {
                            that.fixedLeftmenu = false;
                        }
                    }


                    //滚动条到底部加载数据
                    if (t + wh >= h - 100 && that.openAutoReflash && !that.tableDataFinish) {


                        if (!that.tableDataloading) that.searchForum();
                    }

                    //出现回到顶部按钮
                    if (t > wh) that.scrolltop = true;
                    else that.scrolltop = false;

                }

            }

        }, mounted() {
            this.lander = JSON.parse(this.$store.state.logininfo);
            this.webW = getWindowWidth() >= 1000 ? true : false;


            this.tableData = [];
            this.query.pageNo = 1;
            this.query.keywords = '';

            // if(this.$route.query.indexSearchKeywords!=undefined){
            //     this.query.keywords=this.$route.query.indexSearchKeywords;
            //     this.searchForum();
            // }


            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;

            this.fixedmenu();


        },
        watch: {
            $route: function (value) {
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;

                // if(value.query.indexSearchKeywords!=undefined){
                //     this.query.keywords=this.$route.query.indexSearchKeywords;
                //     this.searchForum();
                // }
            }
        },
        activated() {


            //固定左右菜单
            this.fixedmenu();


        },
        deactivated() {

        }
    };
</script>

<style scoped>


    .mr10 {
        margin-right: 10px;
        width: 150px;
    }


</style>
